import React from 'react';
import { Button } from '@mui/material';

import { useSelector, useDispatch } from 'react-redux';
import { selectSmallScreen } from '../../store/ui/ui.selector';
import { changeSmallScreen } from '../../store/ui/ui.slice';

import './small-screen.styles.scss';

export default function SmallScreen() {
  const dispatch = useDispatch();
  const smallScreen = useSelector(selectSmallScreen);

  const handleClick = () => {
    dispatch(changeSmallScreen({ ...smallScreen, bypass: true }));
  };

  return (
    <div className='small-screen-container'>
      <div className='small-screen-text'>
        This tool was designed to be used with a larger display or window size
        than you are currently using. For the best experience, please increase
        the {smallScreen.reason} of your browser window or view the tool on a
        larger device.
        <br />
        <Button
          onClick={handleClick}
          sx={{
            backgroundColor: 'red',
            border: '1px solid black',
            color: 'white',
            marginTop: '7px',
          }}
        >
          Continue Anyway
        </Button>
      </div>
    </div>
  );
}
